<mat-list-item (click)="navigateToPatientFile(patient.id)" class="auto-height" [appPatientActive]="patient.id"
    [appPatientValidationStatus]="patient" #valStatus="appPatientValidationStatus">
    <div class="list-item">
        <div class="details">
            <app-patient-validation-messages [valStatus]="valStatus"> </app-patient-validation-messages>
            <div matLine class="primary-text">
                <b>{{ patient.surname }}, {{ patient.name }}</b>
                <span class="primary-text-aside" *ngIf="patient.patientNumber">({{ patient.patientNumber }})</span>
            </div>
            <div matLine class="secondary-text">
                <span>{{ patient.diagnosis }}</span>
            </div>
            <div matLine *ngIf="patient.diagnosis2" class="tertiary-text">
                <span>{{ buildDiagnosisString(patient) }}</span>
            </div>
            <div matLine *ngIf="isInpatient && patient.bed" class="tertiary-text">Bed: {{ patient.bed }}</div>
        </div>
        <div class="view-icon" *ngIf="isInpatient">
            <button mat-icon-button matTooltip="Start a ward round recording for this patient"
                (click)="openAIDialog($event, patient.id, patient.groupId)">
                <mat-icon svgIcon="ward_round"></mat-icon>
            </button>
        </div>
        <div class="view-icon" *ngIf="isInpatient" matTooltip="Edit hospital, ward, or bed details for this patient"
            (click)="openEditPatientDialog($event, patient)">
            <button mat-icon-button>
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <div class="view-icon" *ngIf="!isInpatient">
            <button mat-icon-button>
                <mat-icon>visibility</mat-icon>
            </button>
        </div>
    </div>
</mat-list-item>


<ng-template #inpatientDetailsDialog>
    <h1 mat-dialog-title>Bed Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20  field-column">

            <mat-form-field appearance="outline">
                <mat-label>Hospital</mat-label>
                <mat-select [(ngModel)]="editingPatient.hospitalId" (selectionChange)="selectHospital($event)">
                    <mat-option *ngFor="let hospital of hospitals" [value]="hospital.id">{{hospital.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="editingPatient.hospitalId">
                <mat-label>Ward</mat-label>
                <mat-select [(ngModel)]="editingPatient.wardId">
                    <mat-option *ngFor="let ward of wards" [value]="ward.id">{{ward.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Bed</mat-label>
                <input matInput [(ngModel)]="editingPatient.bed">
            </mat-form-field>

        </div>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button (click)="openDischarge()" [disabled]="isLoading">Discharge
            Patient</button>
        <button mat-raised-button color="primary" (click)="saveBedDetails()" [disabled]="isLoading">Save
            Details</button>
    </div>

</ng-template>